import React from "react";

export default function Contact() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20">
      <div className="text-xs uppercase tracking-widest text-slate-500 mb-2">Contact</div>
      <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 brand-heading">Reach us</h1>
      <p className="mt-4 text-slate-700">For demo, product feedback or lender onboarding requests:</p>
      <div className="mt-6 p-6 rounded-lg border border-slate-200 bg-white">
        <div className="text-sm text-slate-600">Email</div>
        <div className="text-lg font-semibold text-slate-900">support@bharatkosh.demo</div>
        <div className="text-sm text-slate-600 mt-4">Grievance</div>
        <div className="text-lg font-semibold text-slate-900">grievance@bharatkosh.demo</div>
        <div className="text-sm text-slate-600 mt-4">Address</div>
        <div className="text-lg font-semibold text-slate-900">Madhya Pradesh MSME Credit Exchange, Bhopal, MP</div>
      </div>
    </div>
  );
}
